<template>
   <svg class="jss1361" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style=""><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.25"></path></svg>
</template>

<script>
export default {
  name: "DownMenuSvg",
};
</script>